var success = "https://shopfront-cdn.tekoapis.com/static/16aee9ad56e6c90c.svg";

export { success as default };
